import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomAlert from "../../components/CustomAlert";
import CustomLoading from "../../components/CustomLoading";
import wsclients from "../../services/wsclients";
import { getAppConfig, getCountryDefaultByCode } from "../../utils/commons";
import { onValidateIdNumber, verify_id_number } from "../../utils/util";
import SettingView from "./SettingView";

export default function SettingController(props) {
    const { t } = useTranslation();
    const [isSendDirectSale, setSendDirectSale] = useState(false);
    const [isSendAffiliate, setSendAffiliate] = useState(false);
    const [avatar, setAvatar] = useState(null);
    const [contactInfo, setContactInfo] = useState(null);
    const [showLoading, onShowLoading] = useState(false);
    const [contactLoading, onContactLoading] = useState(false);
    const [error, setError] = useState({
        showAlert: false,
        close: true,
        message: '',
        status: '',
    });
    const [addressHome, setAddressHome] = useState({});
    const [addressLoading, setAddressLoading] = useState(false);
    const [showFormChangePass, setShowFormChangePass] = useState(false);
    const [fileIdNumber, setFileIdNumber] = useState(null);
    const [filePassport, setFilePassport] = useState(null);
    const [files, setFiles] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [sms_opt_out, setSmsOtpOut] = useState(false);
    const [email_opt_out, setEmailOtpOut] = useState(false);
    const [enable_switch, setEnableSwitch] = useState({
        email_opt_out: true,
        sms_opt_out: true,
        language: true
    });
    const [validations, setValidations] = useState({
        email: undefined,
    });
    const [showLoadingEmail, onShowLoadingEmail] = useState(false);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        await onLoadProfile();
    }

    const onLoadProfile = async () => {
        onContactLoading(true);
        try {
            var result = await wsclients.contacts.getContact();
            console.log("result getContact ===", result);
            if (result.code === 'OK') {
                let newContactInfo = {
                    ...contactInfo,
                    first_name: result.data.first_name ? result.data.first_name : null,
                    last_name: result.data.last_name ? result.data.last_name : null,
                    email: result.data.email ? result.data.email : null,
                    custom_fields: result.data.custom_fields ? result.data.custom_fields : null,
                }
                setSmsOtpOut(result.data.sms_opt_out);
                setEmailOtpOut(result.data.email_opt_out);
                setContactInfo(newContactInfo);
                setAvatar({
                    preview: result.data.avatar_url ? result.data.avatar_url : null
                });
                var demographicsResult = await wsclients.contacts.getContactDemographics();
                console.log('demographicsResult onLoadProfile result=', demographicsResult)
                if (demographicsResult.code === 'OK') {
                    // setContactInfo({
                    //     ...contactInfo,
                    //     id_number: demographicsResult.data.id_details && demographicsResult.data.id_details.id_number ? demographicsResult.data.id_details.id_number : null,
                    //     passport_number: demographicsResult.data.passport && demographicsResult.data.passport.passport_number ? demographicsResult.data.passport.passport_number : null,
                    // });                    
                    setContactInfo(prevState => ({
                        ...prevState,
                        id_number: demographicsResult.data.id_details && demographicsResult.data.id_details.id_number ? demographicsResult.data.id_details.id_number : null,
                        passport_number: demographicsResult.data.passport && demographicsResult.data.passport.passport_number ? demographicsResult.data.passport.passport_number : null,
                    }));
                }
                var phoneResult = await wsclients.contacts.getPhones();
                console.log('MyProfile onLoadProfile phoneResult=', phoneResult)
                if (phoneResult.code === 'OK') {
                    var content = phoneResult.data.content && phoneResult.data.content.length > 0 ? phoneResult.data.content[0] : null;
                    if (content)
                        setContactInfo(prevState => ({
                            ...prevState,
                            phone: content,
                        }));
                }
                var filesResult = await wsclients.lab4services.onGetFiles();
                console.log('onLoadFiles result==', result)
                if (filesResult.code === 'OK') {
                    if (filesResult.data && filesResult.data.length > 0) {
                        setFiles(filesResult.data);
                    }
                }
                await onLoadAddresses(newContactInfo);
            } else {
                showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
            }

        } catch (error) {
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
        onContactLoading(false);
    }

    const onSaveContactInfo = async (values) => {
        console.log("form contact values===", values);
        const { first_name, last_name, id_number, passport_number, email, mobile_number } = values;
        if (id_number || passport_number) {
            onShowLoading(true);
            let validEmail = onHandleBlur(email, 'email');
            let validPhone = onHandleBlur(mobile_number, 'phone');
            let validIdNumber = passport_number ? false : onHandleBlur(id_number, 'id_number');
            if (!validEmail && !validPhone && !validIdNumber) {
                let newDemographic = {
                    passport: {
                        passport_number: passport_number,
                    },
                    id_details: {
                        id_number: id_number,
                    }
                };

                let newProfile = {
                    first_name: first_name,
                    last_name: last_name,
                    email_address: email,
                };

                try {
                    var result = await wsclients.contacts.updateContact({ ...newProfile }, { ...newDemographic });
                    console.log("result getContact ===", result);
                    if (result.code == 'OK') {
                        if (mobile_number) {
                            await checkAndUpdatePhone(mobile_number);
                        }
                        if (attachments && attachments.length > 0) {
                            let filesUploaded = await onUploadFile(attachments);
                            if (filesUploaded) await onAddFilesContact(filesUploaded);
                        }
                        await onLoadProfile();
                        showAlert(t('SUCCESS'), t('PROFILE_UPDATE_SUSCESS'));
                    } else {
                        showAlert(t('ERROR'), t('UPDATE_FAIL'));
                    }
                } catch (error) {
                    showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
                }
            }
            onShowLoading(false);
        }
    }

    const checkAndUpdatePhone = async (new_phone) => {
        try {
            var phone_number = new_phone;
            var currentPhone = contactInfo && contactInfo.phone ? contactInfo.phone : null;
            var isUpdate = false;
            var isAdd = false;
            var isDelete = false;

            if (phone_number && currentPhone && currentPhone.number) {
                if (phone_number != currentPhone.number) {
                    isUpdate = true;
                }
            }
            else if ((!currentPhone || !currentPhone.number) && phone_number) {
                isAdd = true;
            }
            else if (!phone_number && currentPhone && currentPhone.number) {
                isDelete = true;
            }
            if (!isDelete && !isAdd && !isUpdate)
                return true;
            var result = null;
            let phone_new = phone_number.substr(1);
            if (isAdd) {
                result = await wsclients.contacts.addPhone({ number: phone_new, country_code: currentPhone.ccountry_code, is_primary: true });
            }
            if (isUpdate) {
                result = await wsclients.contacts.updatePhone({ number: phone_new, country_code: currentPhone.ccountry_code, phone_id: currentPhone.id });
            }
            if (isDelete) {
                result = await wsclients.contacts.deletePhone(currentPhone.id);
            }
            if (result.code != 'OK') {
                showAlert(t('ERROR'), t('UPDATE_FAIL'));
            } else {
                return true;
            }
        } catch (error) {
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
    }

    const onSendDirectSale = () => {
        setSendDirectSale(!isSendDirectSale);
    }

    const onSendAffiliate = () => {
        setSendAffiliate(!isSendAffiliate);
    }

    const onAddImage = (target, files) => {
        console.log("AAAAAa onUploadFile ===");
        console.log("files===", files);
        if (files && files.length > 0) {
            if (target === 'id_number') setFileIdNumber(files[0]);
            else if (target === 'passport_number') setFilePassport(files[0]);
            else setAttachments(files)
        }
    }

    const onSaveHomeAddress = async (values) => {
        console.log("form home address values===", values);
        var new_address_info = { ...addressHome }

        new_address_info.address_line_1 = values.address_line_1;
        new_address_info.postal_code = values.postal_code;
        new_address_info.town_city = values.town_city;
        new_address_info.state_province_county = values.state_province_county;
        onShowLoading(true);
        try {
            var country_code = new_address_info.country_code;
            //update custom fields
            let newCustomFields = [];
            let custom_fields = contactInfo && contactInfo.custom_fields ? contactInfo && contactInfo.custom_fields : [];                
            if(custom_fields && custom_fields.length > 0){
                let existApartment = custom_fields.filter(x => x.key === 'apartment_number' || x.key === 'apartment_name');
                let otherCustomFiedls = custom_fields.filter(x => x.key !== 'apartment_number' && x.key !== 'apartment_name');
                newCustomFields = otherCustomFiedls;
                if(existApartment && existApartment.length > 0){
                    existApartment.forEach(item => {
                        if (item.key === 'apartment_number') {
                            item.value = values.apartment_number
                        }
                        if (item.key === 'apartment_name') {
                            item.value = values.apartment_name
                        }
                    });
                    newCustomFields = newCustomFields.concat(existApartment);
                }else{
                    newCustomFields.push({
                        key: 'apartment_number',
                        value: values.apartment_number
                    });
                    newCustomFields.push({
                        key: 'apartment_name',
                        value: values.apartment_name
                    });
                }
            }
            console.log("custom_fields update===", newCustomFields);
            if(newCustomFields && newCustomFields.length > 0){
                let resultUpdateCustomFiedls = await wsclients.contacts.updateCustomFieldsContact(newCustomFields);
                if (resultUpdateCustomFiedls.code === 'OK') {
                } else {
                    showAlert(t('SUCCESS'), t('UPDATE_CUSTOM_FIELDS_FAILED'));
                }
            }
            if (new_address_info.id) {
                let result = await wsclients.contacts.updateAddress({ ...new_address_info, country_code: country_code }, new_address_info.id);
                console.log("result:", result);
                if (result.code === 'OK') {
                    await onLoadProfile();
                    showAlert(t('SUCCESS'), t('UPDATE_ADDRESS_SUCCESS'));
                } else if (result.code === 'ADD_ADDRESS_ALREADY_TYPE') {
                    showAlert(t('ERROR'), t('ADD_ADDRESS_ALREADY_TYPE'))
                } else {
                    showAlert(t('ERROR'), t('FAILED_TO_UPDATE_ADDRESS'))
                }
            } else {
                let result = await wsclients.contacts.addAddress({ ...new_address_info, country_code: country_code });
                console.log("result:", result);
                if (result.code === 'OK') {
                    await onLoadProfile();
                    showAlert(t('SUCCESS'), t('ADD_ADDRESS_SUCCESS'));
                } else if (result.code === 'ADD_ADDRESS_ALREADY_TYPE') {
                    showAlert(t('ERROR'), t('ADD_ADDRESS_ALREADY_TYPE'))
                } else {
                    showAlert(t('ERROR'), t('FAILED_TO_ADD_ADDRESS'))
                }
            }
        } catch (error) {
            console.log("update address exception:", error);
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'))
        };
        onShowLoading(false)
    }

    const showAlert = (status, message, close) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            message: message,
            status: status,
            close: close
        });
    }

    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            message: '',
            status: '',
            close: true
        });
    }

    const onChangePassword = async (values) => {
        console.log("values===", values);
        onShowLoading(true);
        if (values && values.new_password) {
            try {
                var updatePassword = await wsclients.contacts.changePassword(values.new_password);
                if (updatePassword.code === 'OK')
                    showAlert(t('SUCCESS'), t('CHANGE_PASSWORD_SUCCESS'));
                else if (updatePassword.code === 'INVALID_CONTACTPASSWORD_EXCEPTION')
                    showAlert(t('ERROR'), t('INVALID_CONTACTPASSWORD_EXCEPTION'));
                else
                    showAlert(t('ERROR'), t('CHANGE_PASSWORD_FAIL'));
            }
            catch (error) {
                console.log("change password exception:", error);
                showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
            }
        }
        setShowFormChangePass(false);
        onShowLoading(false);
    }

    const onLoadAddresses = async (newContactInfo) => {
        setAddressLoading(true)
        try {
            var result = await wsclients.contacts.getAddresses();
            console.log('onLoadAddresses result==', result)
            console.log("onLoadAddresses newContactInfo===", newContactInfo);
            if (result.code === 'OK') {
                if (result.data && result.data.content && result.data.content.length > 0) {
                    let addressHome = result.data.content.filter(add => add.address_type == 'HOME');
                    let address = addressHome && addressHome.length > 0 ? addressHome[0] : null;
                    let customFields = newContactInfo && newContactInfo.custom_fields ? newContactInfo.custom_fields : null;
                    if (customFields && customFields.length > 0) {
                        let existApartmentNumber = customFields.filter(x => x.key === 'apartment_number');
                        if (existApartmentNumber && existApartmentNumber.length > 0) address.apartment_number = existApartmentNumber[0].value;

                        let existApartmentName = customFields.filter(x => x.key === 'apartment_name');
                        if (existApartmentName && existApartmentName.length > 0) address.apartment_name = existApartmentName[0].value;
                    }
                    console.log("address after get data===", address);
                    setAddressHome(address);
                }
            }
        } catch (error) {
            console.log('load addresses exception:', error);
        }
        setAddressLoading(false);
    }

    const onUploadFile = async (filesContact) => {
        let _filesUploaded = [];
        try {
            console.log("filesContact:", filesContact)
            for (let i = 0; i < filesContact.length; i++) {
                const file = filesContact[i];
                const result = await wsclients.config.uploadFilesNew({ file: file });
                if (result.code == 'OK') {
                    if (result.data.id) _filesUploaded.push(result.data.id);
                } else if (result.data && result.data.error == 'COM.CRM.EXCEPTIONS.INVALIDFILETYPEEXCEPTION') {
                    showAlert({ status: true, message: t('INVALID_FILE_TYPE') })
                }
            }
        } catch (error) {
            console.log("onUploadFile exception:", error);
        }
        return _filesUploaded
    }

    const onAddFilesContact = async (filesUploaded) => {
        try {
            for (let i = 0; i < filesUploaded.length; i++) {
                await wsclients.lab4services.onUploadFile(filesUploaded[i]);
            }
            await setAttachments([]);
        } catch (error) {
            console.log("onAddSRAttachment exception:", error);
        }
    }

    const get_url_extension = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    const onOpenFile = async (file) => {
        console.log("file:", file);
        onShowLoading(true);
        try {
            if (file) {
                let extention = get_url_extension(file.name);
                console.log("extention:", extention);
                var result = await wsclients.config.getDetailFile(file.id);
                if (result.code == 'OK') {
                    let url = window.URL.createObjectURL(result.data);
                    window.open(url, '_blank');
                }
            }
        } catch (error) {
            console.log("load files contact exception:", error);
        }
        onShowLoading(false);
    }
    // console.log("contact_info===", contactInfo);

    const onUpdateMarketingInformation = async (type, status) => {
        onShowLoading(true);
        if (!enable_switch[type]) {
            return;
        }
        setEnableSwitch(prevState => ({
            ...prevState,
            [type]: false
        }))
        if (type == 'email_opt_out') {
            setEmailOtpOut(status);
        }
        else if (type == 'sms_opt_out') {
            setSmsOtpOut(status);
        }
        try {
            await wsclients.contacts.updateContactConsents({ [type]: status });
            try {
                let result = await wsclients.contacts.getContact();
                if (result.code === 'OK') {
                    let sms_opt_out = result.data.sms_opt_out;
                    let email_opt_out = result.data.email_opt_out;
                    setSmsOtpOut(sms_opt_out);
                    setEmailOtpOut(email_opt_out);
                    //await cache.setContact(result.data);
                }
            } catch (error) {
                console.log("load contact error:", error);
            }
        } catch (error) {
            console.log("on receive marketing exeption:", error);
        }
        setEnableSwitch(prevState => ({
            ...prevState,
            [type]: true
        }))
        onShowLoading(false);
    }

    const onHandleBlur = (value, target) => {
        let validPhone = false;
        let validPassword = false;
        let validIdNumber = false;
        let validConfirmPassword = false;
        if (target === 'phone') {
            if (!value || isNaN(value)) validPhone = true;
            else if (value && value.length !== 10) {
                validPhone = true;
            } else {
                if (value) {
                    let startItem = value.substr(0, 1);
                    if (startItem !== '0') {
                        validPhone = true;
                    }
                }
            }
            setValidations(prevState => ({
                ...prevState,
                phone: validPhone,
            }));
            return validPhone;
        }
        if (target === 'password') {
            if (!value) {
                validPassword = true;
            } else if (value && value.length < 8) {
                validPassword = true;
            }
            setValidations(prevState => ({
                ...prevState,
                password: validPassword,
            }));
            return validPassword;
        }
        if (target === 'id_number') {
            if (!value) validIdNumber = true;
            if (value && value.length !== 13) {
                validIdNumber = true;
            }
            validIdNumber = verify_id_number(value) ? false : true;
            console.log("onvalidate id number ===", validIdNumber);
            setValidations(prevState => ({
                ...prevState,
                id_number: validIdNumber,
            }));
            return validIdNumber;
        }
        if (target === 'confirm_password') {
            if (!value) validConfirmPassword = true;
            else if (value && value.length < 8) {
                validConfirmPassword = true;
            }
            setValidations(prevState => ({
                ...prevState,
                confirm_password: validConfirmPassword,
            }));
            return validConfirmPassword;
        }
        return false;
    }

    const onCheckEmail = async (email) => {
        try {
            onShowLoadingEmail(true);
            console.log("email===", email.target.value);
            let result = await wsclients.lab4services.onCheckEmailAddress(email.target.value);
            console.log("onCheckEmailAddress result===", result);
            onShowLoadingEmail(false);
            if (result.code === 'OK') {
                if (result.data.result === 'VALID') {
                    setValidations({
                        ...validations,
                        email: false,
                    });
                    return undefined;
                }
            }
            setValidations({
                ...validations,
                email: true,
            })
            return t('Please enter a valid e-mail address');
        }
        catch (ex) {
            console.log("onCheckEmailAddress exception===", ex);
        }
    }

    return (
        <>
            <SettingView
                contactInfo={contactInfo}
                isSendDirectSale={isSendDirectSale}
                isSendAffiliate={isSendAffiliate}
                avatar={avatar}
                contactLoading={contactLoading}
                addressHome={addressHome}
                addressLoading={addressLoading}
                showFormChangePass={showFormChangePass}
                files={files}
                attachments={attachments}
                sms_opt_out={sms_opt_out}
                email_opt_out={email_opt_out}
                validations={validations}
                showLoadingEmail={showLoadingEmail}
                onSaveContactInfo={onSaveContactInfo}
                onSendDirectSale={onSendDirectSale}
                onSendAffiliate={onSendAffiliate}
                onAddImage={onAddImage}
                onSaveHomeAddress={onSaveHomeAddress}
                onChangePassword={onChangePassword}
                setShowFormChangePass={setShowFormChangePass}
                onOpenFile={onOpenFile}
                onUpdateMarketingInformation={onUpdateMarketingInformation}
                onHandleBlur={onHandleBlur}
                onCheckEmail={onCheckEmail}
            />
            {showLoading && <CustomLoading open={showLoading} />}
            <CustomAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                showButtonClose={true}
                message={error.message}
                error={error.status}
            />
        </>
    );
}